<template>
  <div class="app-container">
    <BjPage ref="BjPage" :query-params="queryParams" :col-span="colSpan" :get-action="queryApi" :serial="serial" :selection="selection" :stripe="false" search-btn-hide right-toolbar-hide no-auto-height :auto-scroll="false" row-key="id" :reset-data="resetDataFn" @handleTableDataChange="handleTableDataChange" @handleSelectionChange="handleSelectionChange">
      <template v-slot:tableColumn>
        <el-table-column :label="$t('orderNewPatch.Product')" prop="skuName" align="center" />
        <el-table-column :label="$t('BusinessThirdOrderAdd.form.SKU')" prop="standardSkuCode" align="center" />
        <el-table-column :label="$t('OrdinaryOrderMix.OrderItemTable.SPU')" prop="batchNumList" align="center">
          <template slot-scope="scope">
            <BjSelectLov v-model="scope.row.spuCode" :option-list="scope.row.batchNumList" :placeholder="$t('OrdinaryOrderMix.OrderItemTable.SPU')" clearable />
          </template>
        </el-table-column>
        <el-table-column :label="$t('BusinessThirdOrderAdd.form.Quantity')" prop="quantity" align="center">
          <template slot-scope="scope">
            <el-input-number v-model="scope.row.quantity" :maxlength="MAX_LENGTH.DEFAULT" class="full-width" :min="0" :precision="0" :controls="false" @blur="onBlurQuantity(scope.row)" />
          </template>
        </el-table-column>
        <el-table-column :label="$t('BusinessBatchInventoryQuery.table.usableNum2')" prop="usableNum" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.batchNumList && scope.row.batchNumList.length>0"> {{ scope.row.batchNumList.bjGet(scope.row.spuCode, 'value', 'usableNum') }}</span>
          </template>
        </el-table-column>
        <el-table-column v-if="isTrue" :label="$t('BusinessThirdOrderAdd.form.The')" prop="thirdDiscountAmount" align="center">
          <template slot-scope="scope">
            <BjInputMoney v-model="scope.row.thirdDiscountAmount" :max="
                scope.row.outerSingleSaleAmount * scope.row.quantity -
                  scope.row.businessDiscountAmount
              " />
          </template>
        </el-table-column>
        <el-table-column v-if="!isTrue && isShow" :label="$t('BusinessOrderAuditComSkuList.transPrice')" prop="freight" align="center">
          <template slot-scope="scope">
            <BjInputMoney v-model="scope.row.freight" />
          </template>
        </el-table-column>

        <el-table-column :label="$t('BusinessThirdOrderAdd.form.Operation')" align="center" fixed="right" width="120">
          <template slot-scope="scope">
            <el-button type="text" @click="onDelete(scope.row)">{{ $t('delText') }}</el-button>
          </template>
        </el-table-column>
      </template>
    </BjPage>
  </div>
</template>
<script>
import pageMiXin from '@/utils/page-mixin.js';
import { SKU_GIFT_TYPE_LIST_FOR_CREATE } from '@/utils/constants';
export default {
  name: 'BusinessThirdOrderOrderItemTable',
  components: {},
  mixins: [pageMiXin],
  props: {
    tableData: {
      type: Array,
      default: function() {
        return [];
      },
    },
    defaultQueryParams: {
      type: Object,
      default: () => {
        return {};
      },
    },
    disabled: {
      type: Boolean,
      default: true
    },
    isTrue: {
      type: Boolean,
      default: true
    },
    isShow: {
      type: Boolean,
      default: true
    },
  },
  data() {
    return {
      serial: false,
      selection: true,
      SKU_GIFT_TYPE_LIST_FOR_CREATE,
      // 查询参数
      queryParams: {
        id: null,
      },

      selectedRows: null,
      expandTableSelectedObj: null,
    };
  },
  watch: {},
  created() {
    if (this.defaultQueryParams) {
      this.queryParams = { ...this.queryParams, ...this.defaultQueryParams };
    }
  },
  methods: {
    // 更新父组件数据
    handleTableDataChange(v) {
      const TEMP = this.tableData.map(e => {
        const FIND = (v || []).find(ee => ee.BJ_EBC_ID == e.BJ_EBC_ID);
        if (FIND) {
          return FIND;
        }
        return e;
      });
      this.$emit('update:tableData', TEMP);
    },
    // 主表查询API
    queryApi(queryParams) {
      const start = queryParams.currentPage * queryParams.pageSize;
      const end = queryParams.page * queryParams.pageSize;
      return new Promise(resolve => {
        resolve({
          content: this.tableData.slice(start, end),
          totalElements: this.tableData.length, // 数据总数
        });
      });
    },
    onDelete(row) {
      this.$emit('delete', row);
    },
    handleSelectionChange(d) {
      this.$emit('selection-change', d);
    },
    onChangeGiftFlag(row) {
      this.$nextTick(() => {
        if (row.giftFlag == 1) {
          row.outerSingleSaleAmount = '0.00';
          row.outerSaleAmount = '0.00';
          row.transPrice = '0.00';
          row.businessDiscountAmount = '0.00';
          row.thirdDiscountAmount = '0.00';
        } else {
          this.onBlurQuantity(row);
        }
      });
    },
    onBlurQuantity(row) {
      console.warn('onBlurQuantity', row);
      row.goodsQuantity = row.quantity;
      row.outerSaleAmount = this.$number2money(
        (row.outerSingleSaleAmount || 0) * (row.quantity || 0),
      );
      row.innerSaleAmount = this.$number2money(
        (row.innerSingleSaleAmount || 0) * (row.quantity || 0),
      );
      row.costAmount = this.$number2money((row.costPrice || 0) * (row.quantity || 0));
    },
    /** * */
    resetDataFn(data) {
      return data.map(e => {
        return { BJ_HAS_CHILD: true, BJ_PARENT_ID: null, ...e };
      });
    },
    onSkuLineLog() {},
  },
};
</script>
